export default __webpack_public_path__ + "static/media/5.21.9e43d1b4.mp3";